export const CATEGORIES = [
  {
    slug: "electrical-components",
    name: "Electrical Components",
    icon: "Zap",
    tagline: "Powering industrial control & sensing",
    description: "From contactors and relays to sensors and enclosures — a complete range of certified electrical components for panels, machines and plants.",
    items: [
      "Contactors, Relays & Overload Protection",
      "Limit, Proximity & Photoelectric Sensors",
      "Push Buttons, Indicators & Selector Switches",
      "Control Panels, Enclosures & Junction Boxes",
      "Thermocouples, RTDs & Temperature Gauges",
      "Industrial Cables & Wiring Accessories",
      "LED Lighting & Flow Meters / Valves",
    ],
    brands: ["Siemens", "Schneider Electric", "ABB", "Omron", "Honeywell", "L&T", "Panasonic", "Mitsubishi Electric", "SICK", "Pepperl+Fuchs"],
  },
  {
    slug: "pneumatics-hydraulics",
    name: "Pneumatics & Hydraulics",
    icon: "Wind",
    tagline: "Motion, pressure & fluid power",
    description: "Cylinders, valves, FRLs, pumps and hoses — engineered for reliable actuation across production lines.",
    items: [
      "Pneumatic Cylinders, Actuators & Rotary Drives",
      "FRL Units — Filters, Regulators & Lubricators",
      "Hydraulic Pumps, Motors & Power Packs",
      "Solenoid & Directional Control Valves",
      "Push-in Fittings, Hoses & Quick Couplings",
      "Pressure Gauges & Flow Control Valves",
    ],
    brands: ["Festo", "SMC", "Parker", "CKD", "Janatics", "Camozzi", "Rexroth", "Norgren", "Hydac", "Airtac"],
  },
  {
    slug: "mechanical-items",
    name: "Industrial Mechanical Items",
    icon: "Settings",
    tagline: "Bearings, seals, gears & shafts",
    description: "Precision mechanical parts sourced from world-class OEMs to keep rotating equipment running.",
    items: [
      "Ball, Roller & Thrust Bearings + Pillow Blocks",
      "Oil Seals, Gaskets & Bronze Bushes",
      "Gearboxes, Couplings & Sprockets",
      "Precision Gears (Metal & Engineering Plastic)",
      "Shafts, Crankshafts & Machine Spindles",
      "Cutting Tool Holders & Collets",
    ],
    brands: ["SKF", "NSK", "NTN", "Timken", "FAG", "Schaeffler", "NACHI", "Koyo", "Garlock", "Trelleborg"],
  },
  {
    slug: "industrial-automation",
    name: "Industrial Automation",
    icon: "Cpu",
    tagline: "PLC, HMI, VFD, servo & robotics",
    description: "Full-stack automation hardware — from controllers to motion systems and industrial robotics.",
    items: [
      "PLCs, HMIs & SCADA-ready Controllers",
      "Variable Frequency Drives (VFDs)",
      "Servo Motors, Drives & Motion Systems",
      "Industrial Robotic Arms & Line Automation",
      "Sensors, Encoders & Communication Cables",
      "Industrial Power Supplies",
    ],
    brands: ["Siemens", "ABB", "Rockwell", "Mitsubishi", "Omron", "Yaskawa", "Delta", "Danfoss"],
  },
  {
    slug: "industrial-lubricants",
    name: "Industrial Lubricants",
    icon: "Droplet",
    tagline: "Food-grade, high-temp & specialty oils",
    description: "Lubricants and greases matched to every duty cycle — from food processing to heavy machinery.",
    items: [
      "NSF H1 Food-Grade Lubricants & Greases",
      "High-Temperature & Specialty Greases",
      "Gear Oils & Hydraulic Fluids",
      "Chain, Wire Rope & Open-Gear Lubricants",
      "Anti-Rust, Penetrating & Cleaning Sprays",
      "Cutting & Coolant Oils",
    ],
    brands: ["Castrol", "Mobil", "Shell", "ExxonMobil", "Fuchs", "Motul", "Kluber", "SKF", "BPCL", "HP"],
  },
  {
    slug: "metals-materials",
    name: "Metals & Materials",
    icon: "Layers",
    tagline: "Raw & semi-finished metal supply",
    description: "Structural stock to precision alloys — cut, tested and certified to your specification.",
    items: [
      "Stainless Steel, Mild Steel & Carbon Steel",
      "Cast Iron, Wrought Iron & Galvanized Iron",
      "Alloy Steel, Aluminium & Titanium",
      "Brass, Copper, Zinc, Lead & Tin",
      "Carbide & Specialty Metals",
    ],
    brands: ["JSW", "Tata Steel", "Jindal", "SAIL", "POSCO"],
  },
  {
    slug: "metal-shapes-fittings",
    name: "Metal Shapes & Fittings",
    icon: "Wrench",
    tagline: "Flanges, pipes, fasteners & fittings",
    description: "Standard and custom fittings for piping, structural and fabrication needs.",
    items: [
      "Weld-Neck, Slip-On & Blind Flanges",
      "Seamless & Welded Pipes / Tubes",
      "Elbows, Tees, Reducers & Unions",
      "Nuts, Bolts, Washers & Fasteners",
      "Perforated & Patterned Sheets",
      "Rods, Bars & Couplings",
    ],
    brands: ["Sandvik", "Jindal SAW", "Ratnamani", "Nippon Steel"],
  },
  {
    slug: "conveyor-belts",
    name: "Modular Conveyor Belts",
    icon: "MoveHorizontal",
    tagline: "Modular, mesh & rubber belting",
    description: "Conveyor systems and belting for food, pharma, packaging and heavy industry lines.",
    items: [
      "Plastic Modular Belts",
      "Metal Mesh & Wire Belts",
      "Rubber & PVC Conveyor Belts",
      "Inclined & Curved Belt Conveyors",
      "Roller & Flat-Wire Belt Systems",
    ],
    brands: ["Habasit", "Intralox", "Ammeraal Beltech"],
  },
  {
    slug: "transmission-belts",
    name: "Transmission Belts",
    icon: "RefreshCw",
    tagline: "V-belts, timing, poly & flat belts",
    description: "Engineered for consistent torque transfer across automotive, food-processing and heavy industry.",
    items: [
      "Flat, V & Poly Belts",
      "Timing & Synchronous Belts",
      "Sponge-Coated & Circular Belts",
      "Drive Pulley & Rope Belts",
      "Banded, Teethery & Energy-Saving Belts",
    ],
    brands: ["Gates", "Continental", "Optibelt", "Fenner", "Dayco"],
  },
  {
    slug: "chemicals",
    name: "Utility & Laboratory Chemicals",
    icon: "FlaskConical",
    tagline: "Water treatment & lab reagents",
    description: "ETP, STP, RO and boiler chemistry plus certified lab reagents and cleaning chemicals.",
    items: [
      "ETP & STP Treatment Chemicals",
      "Boiler Water Treatment Chemicals",
      "R.O. Membrane & System Chemicals",
      "Water Treatment Plant Chemicals",
      "Laboratory Reagents & Chemicals",
      "Industrial Cleaning Chemicals",
    ],
    brands: ["Ion Exchange", "Thermax", "Merck", "Sigma-Aldrich"],
  },
  {
    slug: "orings-gaskets",
    name: "O-Rings & Gaskets",
    icon: "Circle",
    tagline: "Sealing & gasket solutions",
    description: "Custom-sized O-rings, gaskets and sealing kits in every elastomer grade and durometer.",
    items: [
      "NBR, Silicon, EPDM, PTFE, Viton, FKM",
      "Custom Sizes & Durometer Ratings",
      "Chemical, Heat & Abrasion-Resistant Grades",
      "Food-Grade & Pharma-Compliant Options",
      "Gaskets Cut to Drawing or Sample",
    ],
    brands: ["Parker", "Trelleborg", "Freudenberg", "Garlock"],
  },
  {
    slug: "safety-items",
    name: "Safety Items",
    icon: "ShieldCheck",
    tagline: "PPE, fire & confined-space gear",
    description: "Certified personal protective equipment and fire-fighting gear for every industry.",
    items: [
      "Helmets, Gloves & Safety Goggles",
      "Safety Shoes & Full-Body Harnesses",
      "Fire Extinguishers & Fire Hose Reels",
      "Hi-Vis Jackets & Complete PPE Kits",
      "Gas Detection & Confined-Space Gear",
    ],
    brands: ["3M", "Honeywell", "Karam", "MSA", "Udyogi"],
  },
  {
    slug: "hardware-tools",
    name: "Hardware & Tools",
    icon: "Hammer",
    tagline: "Power tools, hand tools & storage",
    description: "Complete tooling and hardware kits — from precision drivers to power tools and storage.",
    items: [
      "Power Tools — Drills, Grinders & Saws",
      "Hand Tool Kits & Combination Wrench Sets",
      "Casters, Chains & Industrial Fasteners",
      "Tool Boxes, Clamps & Storage Cases",
    ],
    brands: ["Makita", "Ingco", "Bosch", "Stanley", "Taparia"],
  },
  {
    slug: "cutting-tools",
    name: "Special Cutting Tools",
    icon: "Scissors",
    tagline: "Carbide & HSS cutting tools",
    description: "Precision cutting tools engineered for productivity in milling, turning and drilling.",
    items: [
      "Carbide End Mills & Indexable Inserts",
      "HSS Drills, Cutters & Reamers",
      "Milling & Slotting Cutters",
      "Turning, Boring & Threading Tools",
    ],
    brands: ["Sandvik Coromant", "Kennametal", "Mitsubishi", "Iscar", "OSG"],
  },
  {
    slug: "packaging-materials",
    name: "Packaging Materials",
    icon: "Package",
    tagline: "Flexible & rigid packaging",
    description: "Films, boards, wraps and strapping for product protection, export crating and structural packing.",
    items: [
      "LDPE, HDPE & Stretch Film",
      "Cardboard Sheets & Corrugated Boxes",
      "Plywood, MDF & HDF Boards",
      "Bubble Wrap & Strapping Rolls",
    ],
    brands: ["Uflex", "TCPL", "SIG"],
  },
  {
    slug: "timber-wood",
    name: "Industrial Timber & Wood Packaging",
    icon: "TreePine",
    tagline: "Export-grade timber & pallets",
    description: "Premium timber, plywood and ISPM-15 heat-treated wood for export-ready crating and dunnage.",
    items: [
      "Premium Pine, Teak & Acacia",
      "Sheesham, Kikar, Neem & Babool",
      "ISPM 15 Heat-Treated Wood",
      "Commercial, Decorative & Shuttering Plywood",
      "High-Density MDF Boards",
      "Custom-Cut Dunnage & Crating Blocks",
    ],
    brands: ["Century Ply", "Greenply", "Kitply"],
  },
  {
    slug: "plant-maintenance",
    name: "Utilities & Plant Maintenance",
    icon: "Factory",
    tagline: "STP, ETP, RO & AMC support",
    description: "Turnkey utility systems and maintenance contracts to keep your plant running.",
    items: [
      "STP (Sewage Treatment Plant) Solutions",
      "ETP (Effluent Treatment Plant) Solutions",
      "R.O. (Reverse Osmosis) Plant Systems",
      "Fire Hydrant & Fire-Fighting Systems",
      "Preventive & Breakdown Plant Maintenance",
      "AMC & Turnkey Utility Support",
    ],
    brands: ["Thermax", "Ion Exchange", "VA Tech Wabag"],
  },
];

export const ALL_BRANDS = [
  "Siemens", "Schneider Electric", "ABB", "Omron", "Honeywell", "L&T", "Panasonic",
  "Mitsubishi Electric", "SICK", "Pepperl+Fuchs", "Festo", "SMC", "Parker", "CKD",
  "Janatics", "Camozzi", "Rexroth", "Norgren", "Hydac", "Airtac", "SKF", "NSK",
  "NTN", "Timken", "FAG", "Schaeffler", "NACHI", "Koyo", "Garlock", "Trelleborg",
  "Rockwell", "Yaskawa", "Delta", "Danfoss", "Castrol", "Mobil", "Shell", "ExxonMobil",
  "Fuchs", "Motul", "Kluber", "BPCL", "HP", "JSW", "Tata Steel", "Jindal", "SAIL",
  "Sandvik", "Ratnamani", "Habasit", "Intralox", "Gates", "Continental", "Optibelt",
  "Fenner", "Dayco", "Ion Exchange", "Thermax", "Merck", "Freudenberg", "3M",
  "Karam", "MSA", "Udyogi", "Makita", "Ingco", "Bosch", "Stanley", "Taparia",
  "Kennametal", "Iscar", "OSG", "Uflex", "Century Ply", "Greenply",
];
